import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Autosuggest from "./../components/Autosuggest";
import parse from "autosuggest-highlight/parse";
import shortid from "shortid";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import axiosImport from "axios";
import { taxServiceClient } from "../AxiosClient";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import LinearProgress from "@material-ui/core/LinearProgress";

export class UserAutosuggest extends Component {
  cancelToken = null;
  state = {
    userAutocompleteLoading: false,
    users: [],
  };
  render() {
    return (
      <div style={{ width: "100%" }}>
        {/* <Autosuggest
          // renderSuggestion={this.renderUserSuggestion}
          // inputLabel={this.props.t("user_admin_search_for_user")}
          keepSuggestion={this.keepUserSuggestion}
          getSuggestionValue={this.getUserSuggestionValue}
          clearOnSelect={this.props.clearOnSelect}
          // disabled={this.props.disabled}
          // getSuggestions={this.getSuggestions}
        /> */}

        <Autocomplete
          handleHomeEndKeys
          disabled={this.props.disabled}
          fullWidth
          openOnFocus
          options={this.state.users}
          onChange={(e, selected) => {
            selected && 
              this.props.onItemSelected(selected ? selected : {});
          }}
          getOptionSelected={(op, val) => {
            return op.userLogin === val.userLogin;
          }}
          renderOption={this.renderUserSuggestion}
          onInputChange={this.handleUserSuggestChange}
          getOptionLabel={(option) => option.userLogin}
          renderInput={(params) => (
            <>
              <TextField
                {...params}
                variant="standard"
                label={this.props.t("user_admin_search_for_user")}
              />{" "}
              {this.state.userAutocompleteLoading && (
                <LinearProgress color="secondary" />
              )}
            </>
          )}
        />
      </div>
    );
  }
  handleUserSuggestChange = (_e, newValue) => {
    if (_e.type === "change") {
      this.getSuggestions(newValue);
    }
  };

  getSuggestions = async (value) => {
    if (this.cancelToken && this.cancelToken.cancel) {
      // cancel inflight data request
      this.cancelToken.cancel();
    }
    this.cancelToken = axiosImport.CancelToken.source();
    let userUrl =
      this.props.currentUser.isOperator === 1 && this.props.organization
        ? "/user/?orgId=" + this.props.organization.organizationId + "&"
        : "/user/?";
    let res = { data: { content: [] } };
    try {
      res = await taxServiceClient.get(
        `${userUrl}page=0&size=5&search=${value}`,
        { cancelToken: this.cancelToken.token }
      );
    } catch (e) {
      if (!axiosImport.isCancel(e)) {
        console.error(e);
      }
    }
    this.setState({ users: res.data.content });
  };

  onClick = (selectedUser) => {
    this.props.onItemSelected(selectedUser);
  };

  keepUserSuggestion = (user, input) => {
    const inputLength = input.length;

    let loginMatches =
      user.userLogin.slice(0, inputLength).toLowerCase() === input;
    let firstNameMatches =
      user.firstName.slice(0, inputLength).toLowerCase() === input;
    let lastNameMatches =
      user.surname.slice(0, inputLength).toLowerCase() === input;
    let emailMatches = user.email.slice(0, inputLength).toLowerCase() === input;
    // input is a string, id is a number
    let idMatches = user.id == input; //eslint-ignore-line eqeqeq

    return (
      loginMatches ||
      firstNameMatches ||
      lastNameMatches ||
      emailMatches ||
      idMatches
    );
  };

  getUserSuggestionValue = (suggestion) => {
    return suggestion.userLogin;
  };

  match = (text, query) => {
    if (!("string" === typeof query && "string" === typeof text)) {
      return [];
    }

    let t = text.toLowerCase();
    let q = query.trim().toLowerCase();
    const ql = q.length;

    if (!(0 < ql && 0 < t.length)) {
      return [];
    }

    let r = [];

    let i = t.indexOf(q);
    while (i !== -1) {
      r.push([i, i + ql]);
      i = t.indexOf(q, i + ql);
    }

    return r;
  };

  renderUserSuggestion = (suggestion, query, isHighlighted) => {
    const userLoginMatches = this.match(suggestion.userLogin, query.inputValue);
    const firstNameMatches = this.match(suggestion.firstName, query.inputValue);
    const lastNameMatches = this.match(suggestion.surname, query.inputValue);
    const emailMatches = this.match(suggestion.email, query.inputValue);

    const userLoginParts = parse(suggestion.userLogin, userLoginMatches);
    const firstNameParts = parse(suggestion.firstName, firstNameMatches);
    const lastNameParts = parse(suggestion.surname, lastNameMatches);
    const emailParts = parse(suggestion.email, emailMatches);

    let fnp = firstNameParts.map(
      (part) =>
        part.highlight ? (
          <span key={shortid.generate()} style={{ fontWeight: 500 }}>
            {part.text}
          </span>
        ) : (
          <strong key={shortid.generate()} style={{ fontWeight: 300 }}>
            {part.text}
          </strong>
        )
    );
    fnp.push(" ");

    let lnp = lastNameParts.map(
      (part) =>
        part.highlight ? (
          <span key={shortid.generate()} style={{ fontWeight: 500 }}>
            {part.text}
          </span>
        ) : (
          <strong key={shortid.generate()} style={{ fontWeight: 300 }}>
            {part.text}
          </strong>
        )
    );
    lnp.push(" ");

    let ulp = userLoginParts.map(
      (part) =>
        part.highlight ? (
          <span key={shortid.generate()} style={{ fontWeight: 500 }}>
            {part.text}
          </span>
        ) : (
          <strong key={shortid.generate()} style={{ fontWeight: 300 }}>
            {part.text}
          </strong>
        )
    );

    ulp.unshift("(");
    ulp.push(")");

    let ep = emailParts.map(
      (part) =>
        part.highlight ? (
          <span key={shortid.generate()} style={{ fontWeight: 500 }}>
            {part.text}
          </span>
        ) : (
          <strong key={shortid.generate()} style={{ fontWeight: 300 }}>
            {part.text}
          </strong>
        )
    );

    let primaryText = fnp.concat(lnp).concat(ulp);

    return (
      <ListItem
        selected={query.selected}
        component="div"
        onClick={() => this.onClick(suggestion)}
        style={{ cursor: "pointer" }}
        aria-label="User suggestion"
      >
        <ListItemAvatar>
          <Avatar src={suggestion.avatarBase64} />
        </ListItemAvatar>
        <ListItemText
          secondaryTypographyProps={{ noWrap: true }}
          primary={primaryText}
          secondary={ep}
        />
      </ListItem>
    );
  };
}
const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

export default connect(
  mapStateToProps,
  null
)(withTranslation()(UserAutosuggest));
